import {useMemo} from "react";

import {IInfiniteListQuery} from "@pg-design/infinite-list";
import {abTestingSelector} from "@pg-mono/ab-testing";

import {DSA_RATING_SORT_AB_TEST_ID, isDsaRatingSortTreatmentVariant} from "../../ab_testing/dsa_rating_sort_ab_test";
import {useAppSelector} from "../../store/hooks";
import {getRequestStateFromRtkQuery} from "../../store/utils/get_request_state_from_rtk_query";
import {ILatestQuery} from "../../utils/latest_query";
import {useGetOfferListQuery} from "../api/get_offer_list";
import {getFetchOfferListQueryData} from "../list/helpers/get_fetch_offer_list_query_data";
import {IGetOfferListPayload} from "../types/GetOfferListPayload";
import {IOfferListOffer} from "../types/IOfferListOffer";

interface IQueryValues extends ILatestQuery {
    page: number;
    page_size: number;
}

export function useOfferModalOffers(skipFetch = false, queryValues: IQueryValues, privilegedOffers?: IOfferListOffer[]): IInfiniteListQuery<IOfferListOffer> {
    const useDsaSort = isDsaRatingSortTreatmentVariant(useAppSelector(abTestingSelector(DSA_RATING_SORT_AB_TEST_ID)));
    const {fullQuery} = getFetchOfferListQueryData(
        {
            ...queryValues,
            page: queryValues.page.toString(),
            page_size: queryValues.page_size.toString()
        },
        true,
        useDsaSort
    );

    const {
        data: response,
        isLoading,
        isError,
        isSuccess,
        isFetching,
        isUninitialized
    } = useGetOfferListQuery(
        {
            //  TODO: fix this type casting, create predictable payload based on url parsing and state
            ...(fullQuery as unknown as IGetOfferListPayload),
            page: queryValues.page,
            page_size: queryValues.page_size
        },
        {skip: skipFetch}
    );

    return useMemo(
        () => ({
            count: (response ? response.count : 0) + (privilegedOffers?.length || 0),
            page: response ? response.page : queryValues.page,
            pageSize: response ? response.page_size : queryValues.page,
            data: [...(privilegedOffers || []), ...(response ? response.results : [])],
            isInitialized: !isUninitialized,
            isSuccess,
            isLoading,
            isError,
            requestState: getRequestStateFromRtkQuery({isLoading, isError, isSuccess, isFetching})
        }),
        [privilegedOffers, response, queryValues.page, isSuccess, isLoading, isError, isFetching, isUninitialized]
    );
}
import {useMemo} from "react";

import {IInfiniteListQuery} from "@pg-design/infinite-list";
import {abTestingSelector} from "@pg-mono/ab-testing";

import {DSA_RATING_SORT_AB_TEST_ID, isDsaRatingSortTreatmentVariant} from "../../ab_testing/dsa_rating_sort_ab_test";
import {useAppSelector} from "../../store/hooks";
import {getRequestStateFromRtkQuery} from "../../store/utils/get_request_state_from_rtk_query";
import {ILatestQuery} from "../../utils/latest_query";
import {useGetOfferListQuery} from "../api/get_offer_list";
import {getFetchOfferListQueryData} from "../list/helpers/get_fetch_offer_list_query_data";
import {IGetOfferListPayload} from "../types/GetOfferListPayload";
import {IOfferListOffer} from "../types/IOfferListOffer";

interface IQueryValues extends ILatestQuery {
    page: number;
    page_size: number;
}

export function useOfferModalOffers(skipFetch = false, queryValues: IQueryValues, privilegedOffers?: IOfferListOffer[]): IInfiniteListQuery<IOfferListOffer> {
    const useDsaSort = isDsaRatingSortTreatmentVariant(useAppSelector(abTestingSelector(DSA_RATING_SORT_AB_TEST_ID)));
    const {fullQuery} = getFetchOfferListQueryData(
        {
            ...queryValues,
            page: queryValues.page.toString(),
            page_size: queryValues.page_size.toString()
        },
        true,
        useDsaSort
    );

    const {
        data: response,
        isLoading,
        isError,
        isSuccess,
        isFetching,
        isUninitialized
    } = useGetOfferListQuery(
        {
            //  TODO: fix this type casting, create predictable payload based on url parsing and state
            ...(fullQuery as unknown as IGetOfferListPayload),
            page: queryValues.page,
            page_size: queryValues.page_size
        },
        {skip: skipFetch}
    );

    return useMemo(
        () => ({
            count: (response ? response.count : 0) + (privilegedOffers?.length || 0),
            page: response ? response.page : queryValues.page,
            pageSize: response ? response.page_size : queryValues.page,
            data: [...(privilegedOffers || []), ...(response ? response.results : [])],
            isInitialized: !isUninitialized,
            isSuccess,
            isLoading,
            isError,
            requestState: getRequestStateFromRtkQuery({isLoading, isError, isSuccess, isFetching})
        }),
        [privilegedOffers, response, queryValues.page, isSuccess, isLoading, isError, isFetching, isUninitialized]
    );
}
